import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { BaseBusinessPutRequest } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';
import { IBaseBusinessManageRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessManageRepository';

/**
 * 関連取引を編集する
 */
export class PutBaseBusinessUseCase {
  private repository: IBaseBusinessManageRepository;
  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessManageRepository) {
    this.repository = repository;
  }

  /**
   * 既存の関連取引を編集する
   * @param baseBusiness - 編集する取引情報
   */
  public async execute(baseBusiness: IBusiness): Promise<INetworkResult<void, Error>> {
    const request: BaseBusinessPutRequest = {
      putBaseBusinessRequestInfo: {
        baseBusinessId: baseBusiness.businessId,
        customerName: baseBusiness.customerName ?? '',
        customerNumber: baseBusiness.customerNumber ?? '',
        salesDestinationName: baseBusiness.salesDestinationName ?? '',
        salesDestinationNumber: baseBusiness.salesDestinationNumber ?? '',
        endUser: baseBusiness.endUser,
        baseBusinessResponsibleUserIdList:
          baseBusiness.baseBusinessResponsibleUsers?.map((user) => user.email).filter((userId) => userId !== undefined) ?? [],
      },
    };

    try {
      const response = await this.repository.put(request);

      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の編集に失敗しました'),
          },
        };
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取引情報の編集に失敗しました'),
        },
      };
    }
  }
}
